import classNames from 'classnames';
import React, { useCallback } from 'react';

import { CurrencyInput } from '@eika/currency-input';
import { RadioButtons } from '@eika/radio-button';

import useTranslation from '../../../../hooks/useTranslation';
import { MoneyDirection } from '../transactionFilterTypes';
import { AmountRangeInputProps, CurrencyChangeParam } from './amountRangeTypes';
import { MAX_AMOUNT, MIN_AMOUNT } from './utils/getAmountRange';

import './AmountRangeInput.scss';

type DirectionOptions = { value: MoneyDirection; label: string; key: string }[];

const AmountRangeInput: React.FC<AmountRangeInputProps> = ({
    maxLengthInput = 15,
    decimalScaleInput = 0,
    currency,
    mainLabel,
    fromAmount,
    toAmount,
    maxAmount = MAX_AMOUNT,
    minAmount = MIN_AMOUNT,
    className,
    contentWrapperClassName,
    moneyDirection,
    ...rest
}) => {
    const targetCurrency = String(currency) === 'NOK' || !currency ? ' kr' : String(currency);
    const translation = useTranslation();

    const defineActualAmounts = useCallback(
        (amount: CurrencyChangeParam, isFromAmount = false) => {
            const setMethod = isFromAmount ? fromAmount.onChange : toAmount.onChange;
            setMethod(amount);
        },
        [fromAmount, toAmount],
    );

    const noSelection = typeof moneyDirection.value === 'undefined';

    return (
        // eslint-disable-next-line
        <fieldset className={classNames('sgw-amount-range-input__fieldset', className)} {...rest}>
            <legend className="sgw-amount-range-input__legend">{mainLabel}</legend>
            <div className="amount-range-input__radio-buttons">
                <RadioButtons
                    label=""
                    name="radio-buttons-med-label-horisontal"
                    onChange={(dir) => moneyDirection.set(dir as MoneyDirection)}
                    selectedOption={moneyDirection.value}
                    options={
                        [
                            { value: 'sent', label: translation.transactionFilter.sentDirection, key: 'sent' },
                            {
                                value: 'received',
                                label: translation.transactionFilter.receivedDirection,
                                key: 'received',
                            },
                        ] as DirectionOptions
                    }
                    horizontal
                />
            </div>
            {!noSelection && (
                <>
                    <div className={classNames('sgw-amount-range-input__content-wrapper', contentWrapperClassName)}>
                        <CurrencyInput
                            disabled={noSelection}
                            decimalScale={decimalScaleInput}
                            maxLength={maxLengthInput}
                            suffix={targetCurrency}
                            max={maxAmount}
                            min={minAmount}
                            // eslint-disable-next-line
                            {...fromAmount}
                            onChange={(amount) => defineActualAmounts(amount, true)}
                        />

                        <CurrencyInput
                            disabled={noSelection}
                            decimalScale={decimalScaleInput}
                            maxLength={maxLengthInput}
                            suffix={targetCurrency}
                            max={maxAmount}
                            min={minAmount}
                            // eslint-disable-next-line
                            {...toAmount}
                            onChange={defineActualAmounts}
                        />
                    </div>
                </>
            )}
        </fieldset>
    );
};

export default AmountRangeInput;
